// extracted by mini-css-extract-plugin
export const price = "PriceFromBox-module--price--1LxHl";
export const promo = "PriceFromBox-module--promo--nQiZu";